<!-- #region header -->
<div class="iu-email-editor-header">
  <iu-input-chips-ui
    [addOnBlur]="true"
    [addOnSpace]="true"
    [columnName]="'email-destination'"
    [cssClass]="'p-col-12 iu-email-editor-header-field'"
    [editOnBackspace]="true"
    [inContainer]="true"
    [inputStyle]="{ minWidth: '200px', background: 'var(--email-editor-bg-color-header-field)' }"
    [label]="'email.destination' | translate"
    [matchPattern]="regexMail"
    [(fieldValue)]="to" />
  @if (!displayCC || !displayCCI) {
    <div class="iu-email-editor-header-display-cc-cci">
      @if (!displayCC) {
        <a data-cy="email-add-cc" href="#" (click)="$event.preventDefault(); displayCC = true">
          {{ 'email.addCC' | translate }}
        </a>
      } @else {
        <a data-cy="email-add-cci" href="#" (click)="$event.preventDefault(); displayCCI = true">
          {{ 'email.addCCI' | translate }}
        </a>
      }
    </div>
  }

  @if (displayCC) {
    <iu-input-chips-ui
      [addOnBlur]="true"
      [addOnSpace]="true"
      [columnName]="'email-cc'"
      [cssClass]="'p-col-12 iu-email-editor-header-field'"
      [editOnBackspace]="true"
      [inContainer]="true"
      [inputStyle]="{ minWidth: '200px', background: 'var(--email-editor-bg-color-header-field)' }"
      [label]="'CC'"
      [matchPattern]="regexMail"
      [(fieldValue)]="cc" />
  }

  @if (displayCCI) {
    <iu-input-chips-ui
      [addOnBlur]="true"
      [addOnSpace]="true"
      [columnName]="'email-cci'"
      [cssClass]="'p-col-12 iu-email-editor-header-field'"
      [editOnBackspace]="true"
      [inContainer]="true"
      [inputStyle]="{ minWidth: '200px', background: 'var(--email-editor-bg-color-header-field)' }"
      [label]="'CCI'"
      [matchPattern]="regexMail"
      [(fieldValue)]="cci" />
  }
  <iu-input-text-ui
    [columnName]="'email-subject'"
    [cssClass]="'p-col-12 iu-email-editor-header-field'"
    [label]="'email.subject' | translate"
    [(fieldValue)]="subject" />
</div>
<!-- #endregion -->
<!-- #region body -->
<div class="iu-email-editor-body">
  <div #quillHeader>
    @if (!isMobile) {
      <!-- desktop -->
      <div class="iu-email-editor-body-header">
        <ng-container [ngTemplateOutlet]="headerAndFont" />

        <ng-container [ngTemplateOutlet]="others" />
      </div>
    } @else {
      <!-- mobile -->
      <div class="iu-email-editor-mobile">
        <div class="iu-email-editor-mobile-menu-display" (click)="displayMobileMenu = !displayMobileMenu">
          Menu<span
            style="margin-left: 5px"
            [ngClass]="['fa', displayMobileMenu ? 'fa-chevron-down' : 'fa-chevron-right']"></span>
        </div>
        <div class="iu-email-editor-mobile-menu" [ngStyle]="{ display: displayMobileMenu ? 'flex' : 'none' }">
          <div class="iu-email-editor-mobile-menu-fieldset">
            <ng-container [ngTemplateOutlet]="headerAndFont" />
          </div>
          <div class="iu-email-editor-mobile-menu-fieldset">
            <ng-container [ngTemplateOutlet]="others" />
          </div>
        </div>
      </div>
    }
  </div>
  <div #quillEditor data-cy="email-body" [ngStyle]="style"></div>
</div>
<!-- #endregion -->
<!-- #region footer -->
<div class="iu-email-editor-footer">
  <div class="iu-email-editor-footer-attachement">
    <iu-input-file-ui
      [auto]="true"
      [data]="{ isParam: false, columnName: 'email-fileupload' }"
      [displayButtons]="false"
      [displayFileUploaded]="true"
      [isLoaderActive]="isLoaderActive"
      [multiple]="true"
      [mustGet]="false"
      [styleClass]="'iu-email-editor-fileupload'"
      [type]="'EMAIL_ATTACHEMENT'"
      [uploadedFileList_noFiles]="'email.noAttachedFiles'"
      [uploadedFileList_title]="'email.attachedFilesTitle'"
      [uploadedFiles]="uploadedFiles"
      [uploadingFileList_title]="'email.attachFiles'" />
  </div>
  <div class="iu-email-editor-footer-template">
    @if (templates$ | async; as templates) {
      <ng-container>
        <iu-autocomplete-ui
          #emailModelAutocomplete
          [columnName]="'email-templates'"
          [cssClass]="'p-col-12 iu-email-editor-header-field'"
          [data]="templates"
          [fieldValue]="defaultEmailModel"
          label="{{ 'email.emailModels' | translate }}"
          [limitSuggestions]="3"
          tooltip="{{ 'email.emailModels' | translate }}"
          (autoCompleteEmitter)="selectTemplate($event.model)"
          (fieldValueModified)="defaultEmailModel = $event" />
      </ng-container>
    }
  </div>
  <div class="iu-email-editor-footer-buttons">
    <button class="p-button p-button-secondary" type="button" (click)="cancelEmailEmitter.emit()">
      {{ 'email.cancel' | translate }}
    </button>
    <button
      class="p-button p-button-primary"
      data-cy="email-send-button"
      type="button"
      [disabled]="isLoaderActive"
      (click)="sendEmail($event)">
      {{ 'email.sendEmail' | translate }}
    </button>
  </div>
</div>
<!-- #endregion -->

<!-- #region Templates -->
<ng-template #headerAndFont>
  <select class="ql-header">
    <option value="1">{{ 'email.header.heading' | translate }}</option>
    <option value="2">{{ 'email.header.subheading' | translate }}</option>
    <option selected>{{ 'email.header.normal' | translate }}</option>
  </select>
  <select class="ql-font">
    <option selected>Sans Serif</option>
    <option value="serif">Serif</option>
    <option value="monospace">Monospace</option>
    <option value="calibri">Calibri</option>
    <option value="arial">Arial</option>
    <option value="times-new-roman">Times new roman</option>
  </select>
</ng-template>

<ng-template #others>
  <button
    class="ql-bold"
    type="button"
    [attr.aria-label]="'email.font.weight.bold' | translate"
    [title]="'email.font.weight.bold' | translate">
    {{ 'email.font.weight.bold' | translate }}
  </button>
  <button
    class="ql-italic"
    type="button"
    [attr.aria-label]="'email.font.weight.italic' | translate"
    [title]="'email.font.weight.italic' | translate">
    {{ 'email.font.weight.italic' | translate }}
  </button>
  <button
    class="ql-underline"
    type="button"
    [attr.aria-label]="'email.font.weight.underline' | translate"
    [title]="'email.font.weight.underline' | translate">
    {{ 'email.font.weight.underline' | translate }}
  </button>
  <select
    class="ql-color"
    [attr.aria-label]="'email.color.foreground' | translate"
    [title]="'email.color.foreground' | translate"></select>
  <select
    class="ql-background"
    [attr.aria-label]="'email.color.background' | translate"
    [title]="'email.color.background' | translate"></select>
  <button
    class="ql-list"
    type="button"
    value="ordered"
    [attr.aria-label]="'email.list.ordered' | translate"
    [title]="'email.list.ordered' | translate"></button>
  <button
    class="ql-list"
    type="button"
    value="bullet"
    [attr.aria-label]="'email.list.unordered' | translate"
    [title]="'email.list.unordered' | translate"></button>
  <select class="ql-align" [attr.aria-label]="'email.alignment' | translate" [title]="'email.alignment' | translate">
    <option selected></option>
    <option value="center"></option>
    <option value="right"></option>
    <option value="justify"></option>
  </select>
  <button
    class="ql-link"
    type="button"
    [attr.aria-label]="'email.insert.link' | translate"
    [title]="'email.insert.link' | translate"></button>
  <button
    class="ql-image"
    type="button"
    [attr.aria-label]="'email.insert.image' | translate"
    [title]="'email.insert.image' | translate"></button>
  <button
    class="ql-code-block"
    type="button"
    [attr.aria-label]="'email.insert.code' | translate"
    [title]="'email.insert.code' | translate"></button>
  <button
    class="ql-clean"
    type="button"
    [attr.aria-label]="'email.removeStyles' | translate"
    [title]="'email.removeStyles' | translate"></button>
</ng-template>

<!-- #endregion -->
